<mat-nav-list class="nav-menu sm:relative flex" id="cp2-navigation">
  <div class="logo-back-button-container">
    <app-logo></app-logo>
  </div>

  <!-- Navigation Buttons -->
  <div class="nav-menu-buttons flex flex-grow justify-center items-center">
    <app-navigation-buttons
      class="mx-auto"
      [buttons]="buttons"
      [currentHandyOrientation]="currentHandyOrientation"
      (navigate)="onNavigate($event)"
    >
    </app-navigation-buttons>
    <app-history-navigation></app-history-navigation>
  </div>
</mat-nav-list>
